<template lang="pug">
.ddp.border.border-gray-2(class="lg1024:p-6 p-4", v-if="checkAppearance()")
  .text-lg.font-medium {{ $t('ddp_title') }}
  .flex.justify-between.mb-4(class="lg1024:mb-6")
    span {{ $t('ddp_howpay') }}
    span.hidden(class="lg1024:inline")
      span.text-lighter {{ $t('ddp_your_tax') }}:&nbsp;
      span.font-medium {{ formatMoney($store.state.orderData.DUTY) }}
  .grid.grid-cols-1(class="lg1024:grid-cols-2 lg1024:gap-4 gap-3")
    .border.border-gray-2.delivery-type__item(@click="$emit('switch', true)", :class="{ 'active-delivery-type-item': dutyEnabled }")
      .flex.flex-col.py-4.relative 
        .font-medium {{ $t('ddp_ease_title') }}
        .text-sm.text-lighter {{ $t('ddp_ease_text') }}
    .border.border-gray-2.delivery-type__item(@click="$emit('switch', false)", :class="{ 'active-delivery-type-item': !dutyEnabled }")
      .flex.flex-col.py-4.relative
        .font-medium {{ $t('ddp_myself_title') }}
        .text-sm.text-lighter {{ $t('ddp_myself_text') }}

  .pt-4(class="lg1024:hidden")
    span.text-lighter {{ $t('ddp_your_tax') }}:&nbsp;
    span.font-medium {{ formatMoney($store.state.orderData.DUTY) }}
</template>
<script>
export default {
  name: 'DdpBlock',
  computed: {
    dutyEnabled() {
      return this.$store.state.dutyEnabled
    },
  },
  methods: {
    checkAppearance() {
      const authed = this.$store.state.authed
      const country = ['NO', 'CH'].includes(this.$store.state.country.code)
      const dhl = this.$store.state.selectedDeliveryTypeService === 'I_DHL_X'
      const price =
        +this.$store.state.orderData.DELIVERY_PRICE +
        (authed
          ? +this.$store.state.orderData.PRICE_CLUB
          : +this.$store.state.orderData.PRICE_BASE)
      const isPrice = price > 0
      return country && dhl && isPrice
    },
    formatMoney(value) {
      return new Intl.NumberFormat(this.$store.state.country.code, {
        style: 'currency',
        currency: this.$store.state.currency,
        currencyDisplay:
          this.$store.state.country.code === 'NO' ? 'code' : 'symbol',
        numberingSystem: 'latn',
      }).format(value ?? 0)
    },
  },
}
</script>
